<template>
  <div class="content">
    <!-- 搜索条件 -->
    <div class="serachTerms">
      <div class="select_box">
        <span>组名称：</span>
        <el-input
          v-model="groupName"
          placeholder="请输入组名称"
          style="width: 200px"
        ></el-input>

        <el-button
          @click="handleQuery()"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >

        <el-button
          @click="resetQuery()"
          icon="el-icon-refresh"
          class="sonbtn"
          plain
          >重置</el-button
        >
      </div>
    </div>
    <!-- 操作按钮 -->
    <div class="operaBtn">
      <el-button @click="addExaminee()" v-if="$root.$hasbtn('添加分组')" plain>
        <i class="iconfont icon-action-add-hover"></i>添加分组
      </el-button>
      <el-button @click="batchDeleteGroup" v-if="$root.$hasbtn('批量删除分组')" :disabled="multiple" plain>
        <i class="iconfont icon-batch-shanchu"></i>批量删除分组</el-button
      >
    </div>
    <!-- 表格内容 -->
    <div class="examGroupTable">
      <el-table
        ref="table"
        :data="getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @row-click="StepsListRowClick"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column
          type="selection"
          width="60"
          align="center"
        ></el-table-column>

        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template></el-table-column
        >

        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
          <template slot-scope="scope">
            <p v-if="index == 0">{{ scope.row.groupName }}</p>
            <p v-if="index == 1">{{ scope.row.count }}</p>
          </template>
        </el-table-column>

        <el-table-column prop="address" label="操作" align="center" width="360">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                @click.stop="editClick(scope.row)"
                type="text"
                size="small"
                v-if="$root.$hasbtn('编辑')"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('成员管理')"
                @click.stop="memberManagescope(scope.row)"
                >成员管理</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('删除')"
                @click.stop="groupDelete(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="footBox">
      <div class="footPage">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          @prev-click="handlePrevClick"
          @next-click="handleNextClick"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 添加/编辑分组弹框 -->
    <div class="divideGroupsDialog">
      <el-dialog
        :title="!isEdit ? '添加分组' : '编辑分组'"
        :visible.sync="dialogGroupVisible"
        :before-close="handleClose"
      >
        <create-or-edit
          :is-edit="isEdit"
          :group-Id="groupId"
          ref="child"
          :key="timer"
          @success="handleSuccess"
          @cancel="handleCancel"
        >
        </create-or-edit>
      </el-dialog>
    </div>
    <!-- 批量删除分组弹框 -->
    <div class="deleteBatches">
      <el-dialog :title="typeTitle" :visible.sync="dialogDelGroupVisible">
        <span>{{ content }}</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogDelGroupVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSure()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import { ExamGroupData } from "@/state/getListData";
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";
import {
  groupList,
  groupStudentList,
  groupAdd,
  groupDelete,
  groupDeleteBatch,
} from "@/services/examManager.js";
import CreateOrEdit from "./DivideGroupsDialog.vue";
import eventBus from "@/utils/eventBus.js";

export default {
  name: "examGroupList",
  components: {
    CreateOrEdit,
  },
  props: ["changes"],
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      rowData: {},
      userName: "",
      isLoading: false,
      loading: true,
      // 组名称
      groupName: "",
      value_office: "",
      // 考生组列表数据
      ExamGroupData: [],
      // 表格数据请求数据
      grouplistPara: new Object(),
      // 表格数据源
      getData: [],
      currentPage: 1, //  当前页数
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 100,
      dialogGroupVisible: false,
      // 删除分组弹框状态
      dialogDelGroupVisible: false,
      // 添加考生弹框状态
      dialogAddExamVisible: false,
      isEdit: true,
      // 头部文字
      typeTitle: "",
      // 弹框内容
      content: "",
      groupId: Number,
      timer: "",
      editMemberData: [],
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      multipleSelectionAll: [], // 所有选中的数据包含跨页数据
      multipleSelection: [], // 当前页选中的数据
      changePageCoreRecordDataStats: true,
      idKey: "groupID",
      // 表头名称数据
      formColumns: [
        {
          prop: "groupName",
          label: "组名称",
        },
        {
          prop: "count",
          label: "人数",
        },
      ],
      // 列的信息
      delGroupRow: "",
      status: "",
    };
  },
  methods: {
    // pageData: (number, pageSize, data) => {
    //   const pageList = [];
    //   const start = pageSize * number - pageSize;
    //   const end = pageSize * number;
    //   for (let i = start; i < end; i++) {
    //     pageList.push(data[i]);
    //   }
    //   const list = pageList.filter((item) => item);
    //   return list;
    // },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 设置选中的方法
    setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();
      for (var i = 0; i < this.getData.length; i++) {
        if (selectAllIds.indexOf(this.getData[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="table"
          this.$refs.table.toggleRowSelection(this.getData[i], true);
        }
      }
    },

    // 记忆选择核心方法
    changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      let selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      let selectIds = [];
      // 获取当前页选中的id
      this.multipleSelection.forEach((row) => {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      let noSelectIds = [];
      // 得到当前页没有选中的id
      this.getData.forEach((row) => {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach((id) => {
        if (selectAllIds.indexOf(id) >= 0) {
          for (let i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] == id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },

    // 得到选中的所有数据
    getAllSelectionData() {
      // 再执行一次记忆勾选数据匹配，目的是为了在当前页操作勾选后直接获取选中数据
      this.changePageCoreRecordData();
      return this.multipleSelectionAll;
    },

    // 得到选中的所有数据的id
    getAllSelectionUserID() {
      let data = this.getAllSelectionData();
      let groupIDs = [];
      data.forEach((element) => {
        groupIDs.push(element.groupID);
      });
      return groupIDs;
    },

    // 显示条数
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      this.changePageCoreRecordData();
      this.pageSize = val;
      this.examGroupListData();
      console.log(`每页 ${val} 条`);
    },

    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.changePageCoreRecordData();
      this.currentPage = val;
      this.changePageCoreRecordDataStats = false;
      this.examGroupListData();
    },

    // 上一页
    handlePrevClick() {
      this.examGroupListData();
    },
    // 下一页
    handleNextClick() {
      this.examGroupListData();
    },

    // 多选框选中数据
    handleSelectionChange(selection) {
      console.log("多选框选中数据...");
      this.multipleSelection = selection;
      if (this.changePageCoreRecordDataStats) {
        this.changePageCoreRecordData();
      }
      this.multiple = !this.multipleSelectionAll.length;
      // this.ids = selection.map((item) => item.groupID.toString());
      // this.multiple = !selection.length;
      // this.single = selection.length != 1;
      // console.log(this.ids);
    },

    // 取消
    handleCancel() {
      this.dialogGroupVisible = false;
    },
    // 确定
    handleSuccess() {
      this.dialogGroupVisible = false;
      // 刷新列表
      this.examGroupListData();
    },

    //编辑和新增关闭对话框时触发
    handleClose(done) {
      this.$refs.child.GroupForm = {};
      this.$refs.child.$refs.GroupForm.resetFields();
      done();
    },

    // 确定
    handleSure() {
      switch (this.status) {
        case 0:
          this.deleteGroup(this.delGroupRow);
          this.dialogDelGroupVisible = false;
          break;
        case 1:
          this.groupDeleteBatch();
          this.dialogDelGroupVisible = false;
          break;
        default:
          break;
      }
    },

    // 封装方法
    UtilFun(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },

    // 添加组
    async addGroupName() {
      const groupPara = {};
      this.UtilFun(groupPara);
      groupPara.groupName = this.groupName;
      console.log(groupPara);
      try {
        const { data } = await groupAdd(groupPara);
        if (data.Status === 200) {
          console.log(data, "添加组");
          this.$message.success("添加组成功");
          this.examGroupListData();
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 删除组
    async deleteGroup(row) {
      const deleteGroupPara = {};
      this.UtilFun(deleteGroupPara);
      deleteGroupPara.groupID = row.groupID;
      const { data } = await groupDelete(deleteGroupPara);
      console.log(data);
      if (data.Status === 200) {
        this.$message.success("删除组成功");
        this.examGroupListData();
      } else {
        this.$message.error(data.Data);
      }
    },

    // 批量删除组
    async groupDeleteBatch() {
      const deleteGroupPara = {};
      this.UtilFun(deleteGroupPara);
      //const realArr = Array.prototype.slice.call(this.ids);
      const realArr = `[${this.getAllSelectionUserID()}]`;
      deleteGroupPara.groupIDArr = realArr;
      console.log(deleteGroupPara, "<<===批量删除组请求参数");
      const { data } = await groupDeleteBatch(deleteGroupPara);
      console.log(data);
      if (data.Status === 200) {
        this.$message.success("批量删除组成功");
        this.examGroupListData();
        this.multiple = true;
      } else {
        this.$message.error(data.Data);
      }
    },

    // 考生组列表
    async examGroupListData() {
      this.loading = true;
      const grouplistPara = this.grouplistPara;
      this.UtilFun(grouplistPara);
      grouplistPara.pageIndex = this.currentPage - 1;
      grouplistPara.eachPageNum = this.pageSize;
      console.log(grouplistPara, "考生组列表请求数据");
      this.isLoading = true;
      const { data } = await groupList(grouplistPara);
      console.log(data, "考生组列表返回数据");
      if (data.Status === 200) {
        this.isLoading = false;
        // console.log(data.Data.data);
        this.ExamGroupData = data.Data.data;
        this.getData = this.ExamGroupData;
        this.total = data.Data.count;
        setTimeout(() => {
          this.changePageCoreRecordDataStats = true;
          this.loading = false;
          this.setSelectRow();
        }, 200);
      } else {
        this.$message.error(data.Data);
      }
    },

    // // 成员管理列表数据
    // async memberManageListData(row) {
    //   const memberListPara = new Object();
    //   this.UtilFun(memberListPara);
    //   // 分组ID
    //   memberListPara.groupID = row.groupID;
    //   memberListPara.pageIndex = this.currentPage - 1;
    //   memberListPara.eachPageNum = this.pageSize;
    //   // 查询条件
    //   memberListPara.searchStr = "";
    //   console.log(memberListPara);
    //     const { data } = await groupStudentList(memberListPara);
    //     if (data.Status === 200) {
    //       console.log(data);
    //       const memberArr = data.Data || [];
    //       // 给bus触发自定义事件，传递数据
    //       eventBus.$emit("memberListChanges", memberArr);
    //     }else {
    //       this.$message.error(data.Data);
    //     }

    // },

    // 成员管理
    memberManagescope(row) {
      this.rowData = row;
      this.$parent.rowObj = row
      localStorage.setItem("isreload", true);
      this.Buriedpoint({
        code: "Examinee:ListOfGroups:members",
        parent_code: "Examinee:ListOfGroups",
      });
      this.changes(1);
      // this.memberManageListData(row);
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    // 编辑分组
    editClick(row) {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:edit",
          parent_code: "Examinee:ListOfGroups",
        },
        "statetime"
      );
      this.isEdit = true;
      this.dialogGroupVisible = true;
      console.log(row, "编辑");
      this.editMemberData = [];
      this.editMemberData.push(row.groupName, row.groupID);
      this.timer = new Date().getTime();
    },
    // 删除分组
    groupDelete(rowIndex) {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:delete",
          parent_code: "Examinee:ListOfGroups",
        },
        "statetime"
      );
      this.status = 0;
      this.delGroupRow = rowIndex;
      this.typeTitle = "删除分组";
      this.content = "是否删除该分组？";
      this.dialogDelGroupVisible = true;
      console.log(rowIndex, "删除");
    },
    // 添加分组
    addExaminee() {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:add",
          parent_code: "Examinee:ListOfGroups",
        },
        "statetime"
      );
      this.isEdit = false;
      this.dialogGroupVisible = true;
    },
    // 批量删除分组
    batchDeleteGroup() {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:batchDelete",
          parent_code: "Examinee:ListOfGroups",
        },
        "statetime"
      );
      this.status = 1;
      this.typeTitle = "批量删除分组";
      this.content = "是否批量删除选中分组？";
      this.dialogDelGroupVisible = true;
    },

    // 搜索
    async handleQuery() {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:search",
          parent_code: "Examinee:ListOfGroups",
        },
        "statetime"
      );
      // 初始化多选框
      this.multiple = true;
      this.multipleSelectionAll = [];
      this.multipleSelection = [];
      this.changePageCoreRecordDataStats = true;
      // 初始化查询接口请求参数
      //this.pageSize = 0;
      this.currentPage = 1;
      if (this.groupName) {
        this.grouplistPara.searchStr = this.groupName;
      } else {
        this.grouplistPara.searchStr = "";
      }
      this.examGroupListData();
    },

    // 重置
    async resetQuery() {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:rest",
          parent_code: "Examinee:ListOfGroups",
        },
        "statetime"
      );
      // 初始化条件筛选框
      this.groupName = "";
      // 初始化多选框
      this.multiple = true;
      this.multipleSelectionAll = [];
      this.multipleSelection = [];
      this.changePageCoreRecordDataStats = true;
      // 初始化查询接口请求参数
      this.currentPage = 1;
      this.grouplistPara.searchStr = "";
      this.examGroupListData();
    },
  },
  activated() {
    // 考生组列表刷新
    this.examGroupListData();
  },
  created() {
    this.stateArr = [];
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  width: 100%;
  padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
.serchTerms {
  height: 81px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-right: 20px;
  span {
    width: 75px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 21px;
    color: #333333;
    margin-right: 5px;
  }
}

.searchbtn {
  width: 88px;
  height: 40px;
  background: #1890ff;
  opacity: 1;
  border-radius: 4px;
  margin-left: 24px;
  margin-right: 12px;
}

.operaBtn {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 849px;
  height: 40px;
  opacity: 1;

  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 114px;
    margin-top: 30px;
    height: 40px;
    margin-right: 12px;
  }
  .el-button:nth-child(2) {
    background: #e54d4d;
    width: 136px;
    margin-top: 30px;
    height: 40px;
  }
}
// 表格内容
::v-deep .el-table {
  margin-top: 60px;
}
::v-deep .el-table th {
  width: 100%;
  height: 60px;
  background: #8fcbff;
  color: #333333;
  opacity: 1;
}

::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}

.examGroupTable {
  min-height: 460px;
  .el-button {
    font-size: 16px;
  }
}

::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

// 弹框头部
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}

// 弹框头部样式
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}

//
::v-deep .divideGroupsDialog .el-dialog {
  width: 537px;
  height: 247px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      height: 21px;
      line-height: 20px;
      ::v-deep .el-input {
        width: 380px;
      }
      .son_input > input {
        width: 380px;
      }
    }
  }
}

::v-deep .divideGroupsDialog .el-input {
  width: 380px;
}

::v-deep .divideGroupsDialog .el-form-item label {
  width: 100px !important;
  text-align: left;
  margin-left: 15px;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  font-family: "Microsoft YaHei";
}

// 批量删除弹框
::v-deep .deleteBatches .el-dialog {
  width: 400px;
  height: 211px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
  .dialog-footer {
    text-align: center;
    align-content: center;
    align-items: center;
    .el-button {
      margin-right: 30px;
    }
  }
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

// 分页
.footBox {
  position: relative;
  height: 110px;
  .footPage {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
  }
  .pagination {
    ::v-deep .el-pager {
      li {
        border: 1px solid #d9d9d9;
        margin-right: 8px;
        &.active {
          color: #ffffff;
          background-color: #409eff;
          border: none;
        }
      }
    }
    ::v-deep .el-pagination__jump {
      margin: 0px 10px 0px 0px !important;
    }
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
</style>
